import { Col, Form, Modal, Row, Skeleton, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaCheckbox } from "apps/Common/MazakaCheckbox";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { MazakaPassword } from "apps/Common/MazakaPassword";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import useMazakaForm from "hooks/useMazakaForm";
import { useDispatch, useSelector } from "react-redux";
import { handleSetDoneSteps, handleSetEmail, handleSetTempFormData } from "../ClientSideStates";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { useEffect, useState } from "react";
import CorporateAccountAgreement from "./CorporateAccountAgreement";
import { RootState } from "store/Reducers";

const BasicInfo = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [isResetPassValidation, setIsResetPassValidtion] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [isShowAgreemntModal, setIsShowAgreementModal] = useState(false);
  const { email } = useSelector((state: RootState) => state.institutional);
  const contract = useGetContractByType("2");
  const { Text } = Typography;

  useEffect(() => {
    form.setFieldsValue({
      email: email,
    });
  }, [email]);

  const handleOnFinish = async () => {
    const formValues = form.getFieldsValue();
    const acceptedConstratId = contract?.data?.data?.id;

    formValues["selectedContract"] = [acceptedConstratId];
    delete formValues[contract?.data?.data?.name];

    // Redux'a form datayı kaydet
    dispatch(handleSetTempFormData({ data: formValues }));

    // Step ilerlet
    dispatch(handleSetEmail({ email: formValues["email"] }));
    dispatch(handleSetDoneSteps({ data: [0, 1] }));
    props.setCurrentStep(2);
  };

  return (
    <>
      <Col span={24}>
        <MazakaForm submitButtonVisible={false} form={form} onFinish={handleOnFinish}>
          <Row gutter={[10, 20]} className="!px-4">
            <MazakaInput
              xs={24}
              name={"email"}
              label={"E-Posta"}
              className="!m-0"
              inputClassName="!bg-[#f7f7f7] !p-2"
              rules={[
                { type: "email", message: "E-Posta Formatı Geçersiz" },
                { required: true, message: "" },
              ]}
              placeholder={"E-Posta"}
            />

            <Col span={24}>
              <Row gutter={[10, 20]}>
                <MazakaPassword
                  label={"Şifre"}
                  isResetPassValidation={isResetPassValidation}
                  setIsResetPassValidation={setIsResetPassValidtion}
                  inputClassName="!bg-[#f7f7f7] !p-2"
                  name={"password"}
                  rules={[{ required: true, message: "" }]}
                  placeholder={"Şifre"}
                  className="!m-0"
                  span={24}
                />
              </Row>
            </Col>

            <Skeleton loading={contract.isLoading || contract.isFetching}>
              {contract?.data?.data && (
                <MazakaCheckbox
                  rules={[{ required: true, message: "" }]}
                  name={contract?.data?.data?.name}
                  text={
                    <Text className="!text-[#606060]">
                      <Text
                        className="!text-[#1878ff] !cursor-pointer"
                        onClick={() => setIsShowAgreementModal(true)}
                      >
                        {contract?.data?.data?.title || ""}
                      </Text>{" "}
                      kabul ediyorum.
                    </Text>
                  }
                />
              )}
            </Skeleton>

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Devam Et
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>

      <Modal
        open={isShowAgreemntModal}
        onCancel={() => setIsShowAgreementModal(false)}
        width={"80%"}
        footer={false}
      >
        <CorporateAccountAgreement containerClassNames={"!px-4"} />
      </Modal>
    </>
  );
};

export default BasicInfo;
